import React from 'react'
import { 
	ChevronUpIcon,
	ChevronDownIcon
} from '@heroicons/react/20/solid';

export default function EpisodeToggle(props) {
	return (
		<div className='episodeToggle' onClick={props.toggleEpisodesShow}>
			{ props.showEpisodes && <span><ChevronUpIcon style={{width: '1rem'}}/><br/></span> }
			{ props.showEpisodes ? 'Hide' : 'Show' } Episodes
			{ !props.showEpisodes && <span><br/><ChevronDownIcon style={{width: '1rem'}}/></span> }
		</div>
	);
}